<template>
    <div :data-scrolling="scrollThreshold" class="row" id="btnTop">
        <div class="col-4 text-left">
            <h4 class="card-title">
                {{ titlePage }} #
                <span v-if="numdoc != null">{{ numdoc }}</span>
                <span v-else>0000</span>
                <button v-if="numdoc != null" @click="openNotes" type="button" title="Edit Notes"
                    class="btn btn-secundary" style="padding: 0px 3px; font-size: 10px; height: 16px;">
                    <i class="far fa-sticky-note"></i>
                    Edit Note
                </button>
            </h4>
        </div>
        <div class="col-8">
            <div class="botonera text-right">
                <button type="button" class="btn btn-success btn-sm" @click="saveReturn" :disabled="saveDisabled">
                    <i class="fas fa-save"></i> SAVE
                </button>
                <button type="button" class="btn btn-secundary btn-sm" style="margin-right: 5px; margin-left: 5px"
                    @click="$router.push({ name: rutaBackList })">
                    <i class="fas fa-times"></i> CANCEL
                </button>
                <button type="button" class="btn btn-danger btn-sm" @click="deleteReturn"
                    v-if="actionNname == 'update'">
                    <i class="fas fa-trash-alt"></i> DELETE
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        titlePage: {
            type: String,
            default: 'Estimate'
        },
        numdoc: {
            type: [String, Number],
            default: null
        },
        idDoc: {
            type: [String, Number],
            default: null,
            required: false
        },
        saveDisabled: {
            type: Boolean,
            default: false
        },
        rutaBackList: {
            type: String,
            default: ''
        },
        actionNname: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            scrollThreshold: 100,
            sendSave: 0,
            isDesktop: true,
        };
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.checkIsDesktop);
        window.addEventListener('resize', this.getMaxWidthContainer);
        this.checkIsDesktop(); // validar al cargar
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.checkIsDesktop);
        window.addEventListener('resize', this.getMaxWidthContainer);
    },
    methods: {
        checkIsDesktop() {
            this.isDesktop = window.innerWidth > 992;
        },
        handleScroll() {
            if (!this.isDesktop) return;
            const scrollTopBtn = document.getElementById('btnTop');
            const scrollingData = scrollTopBtn?.dataset.scrolling;
            if (scrollingData && scrollingData !== '') {
                if (window.scrollY > parseInt(scrollingData)) {
                    scrollTopBtn.classList.add('active');
                    this.getMaxWidthContainer();
                } else {
                    scrollTopBtn.classList.remove('active');
                }
            } else {
                if (window.scrollY > parseInt(scrollingData)) {
                    scrollTopBtn.classList.add('active');
                    this.getMaxWidthContainer();
                } else {
                    scrollTopBtn.classList.remove('active');
                }
            }
        },
        getMaxWidthContainer() {
            if (!this.isDesktop) return;
            const elemt = document.getElementById('btnTop');
            const formDoc = document.getElementById('body-form');
            const rect = formDoc.getClientRects();
            if (rect.length === 0) return 0;
            if (rect.length > 0) {
                elemt.style.maxWidth = (rect[0].width).toString() + 'px';
            }
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        saveReturn() {
            this.sendSave += 1;
            this.$emit('saveReturn', this.sendSave);
        },
        deleteReturn() {
            this.$emit('deleteReturn', this.idDoc);
        },
        openNotes() {
            this.$emit('openNotes', this.idDoc);
        },
    }
};
</script>

<style scoped>
/* Estilos opcionales para el botón scroll-top */
#btnTop {
    transition: opacity 0.3s ease;
}

/*solo para ipad en adelante*/
@media (min-width:992px) {
    #btnTop.active {
        position: fixed;
        top: 30px;
        z-index: 99;
        width: 100%;
        max-width: 1000px;
        min-width: 800px;
        background: #fff;
        border: 1px solid #ccc;
        padding-top: 15px;
        padding-bottom: 10px;
        margin: auto;
        margin-left: -25px;
    }
}
</style>
